import React, { FC, Suspense } from 'react'
import { Box, CircularProgress } from '@mui/material'
import AppContextModal from '../../../../../components/AppModal/AppContextModal'

interface TasksAddNewModalProps {
	children?: React.ReactNode
}

const TasksAddNewModal: FC<TasksAddNewModalProps> = ({
	children,
}: TasksAddNewModalProps) => {
	return (
		<AppContextModal
			title={'Add new task'}
			openModalButtonText={'+ Add New Task'}
			width={'75.625rem'}
			buttonColor={'primary'}
			openButtonSx={{
				height: '2.75rem',
				width: '10.1875rem',
			}}
		>
			<Suspense
				fallback={
					<Box
						display={'flex'}
						alignItems={'center'}
						justifyContent={'center'}
						my={'auto'}
						py={50}
					>
						<CircularProgress />
					</Box>
				}
			>
				{children}
			</Suspense>
		</AppContextModal>
	)
}

export default TasksAddNewModal
